import { useCallback } from 'react';

import type { ActivityViewProps } from '../../core/types/activity.types';
import { NumberLineView } from './NumberLineView';

export function NumberLineActivityView(props: ActivityViewProps<'number_line'>) {
  const answers = props.runtime?.answers ?? {};

  const onAnswerChange = useCallback(
    (value: number, answer: string) => {
      props.dispatch({
        type: 'SUBMIT',
        payload: { [String(value)]: answer },
      });
    },
    [props.dispatch],
  );

  return (
    <NumberLineView
      payload={props.payload}
      answers={answers}
      interactive={!props.readOnly && props.role === 'student'}
      onAnswerChange={onAnswerChange}
    />
  );
}
